module.exports = __webpack_public_path__ + "img/excel.a979f6be.png";